export interface ICron {
    id: number,
    taskId: string,
    description: string,
    groupName: string,
    allowManualExecution: boolean
}